import { render, staticRenderFns } from "./ValidFormalizacionActas.vue?vue&type=template&id=439c17ed"
import script from "./ValidFormalizacionActas.vue?vue&type=script&lang=js"
export * from "./ValidFormalizacionActas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439c17ed')) {
      api.createRecord('439c17ed', component.options)
    } else {
      api.reload('439c17ed', component.options)
    }
    module.hot.accept("./ValidFormalizacionActas.vue?vue&type=template&id=439c17ed", function () {
      api.rerender('439c17ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/ValidFormalizacionActas.vue"
export default component.exports